const env = import.meta.env;

const name = env.VITE_SCHOOL_NAME?.trim() || 'Smart School Systems';
const shortName = env.VITE_SCHOOL_SHORT_NAME?.trim() || name;
const initial = (env.VITE_SCHOOL_INITIAL?.trim() || name).charAt(0).toUpperCase();
const locality = env.VITE_SCHOOL_LOCALITY?.trim() || '';
const tagline = env.VITE_SCHOOL_TAGLINE?.trim() || '';

export const branding = {
  name,
  shortName,
  initial,
  locality,
  tagline,
} as const;

export type Branding = typeof branding;
